import type {Result, UseCase} from 'framework';
import type {CatalogCandidate} from '../../domain/catalog-candidate';
import type {ProductError} from '../../domain/errors';
import type {ProductRepository, SearchCatalogCandidatesInput} from '../ports/product.repository';

export class SearchCatalogCandidates implements UseCase<
  [SearchCatalogCandidatesInput],
  readonly CatalogCandidate[]
> {
  constructor(private readonly repository: ProductRepository) {}

  execute(
    input: SearchCatalogCandidatesInput,
  ): Promise<Result<readonly CatalogCandidate[], ProductError>> {
    return this.repository.searchCatalogCandidates(input);
  }
}
